import { createModalStore } from '@/shared/lib/modal';

import { LimitedFeature, PlanCategoriesKeys } from '../lib/types';

type UseUpgradePlanModalProps = {
  limitedFeature?: LimitedFeature;
  plan?: PlanCategoriesKeys;
};

const initialState: UseUpgradePlanModalProps = {
  limitedFeature: undefined,
};

export const useUpgradePlanModalStore = createModalStore<UseUpgradePlanModalProps>(initialState, false);
